import { Theme } from '@mui/material';

import { TrendBadgeColors } from './trend-badge.types';

export const getTrendBadgePalette = (theme: Theme, color: TrendBadgeColors) => {
  if (color === 'green') {
    return { foreground: theme.palette.success.dark, background: theme.palette.success.light };
  }

  if (color === 'red') {
    return { foreground: theme.palette.error.dark, background: theme.palette.error.light };
  }

  if (color === 'yellow') {
    return { foreground: theme.palette.warning.dark, background: theme.palette.warning.light };
  }

  return { foreground: theme.palette.default.dark, background: theme.palette.default.light };
};
